"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var warnMissingIndex_1 = __importDefault(require("@seaweb/coral/utils/warnMissingIndex"));
var TabsContext_1 = require("./TabsContext");
var TabPanelContent = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  flex-shrink: 0;\n  transition: all 0.2s ease, transform 0s linear;\n\n  &[data-coral-hidden] {\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  width: 100%;\n  flex-shrink: 0;\n  transition: all 0.2s ease, transform 0s linear;\n\n  &[data-coral-hidden] {\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var typography = _a.theme.typography;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", "px;\n  "], ["\n    font-family: ", ";\n    font-size: ", "px;\n  "])), typography.main, typography.sizes.main);
}, function (_a) {
    var cycle = _a.cycle;
    return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    transform: translateX(", "%);\n  "], ["\n    transform: translateX(", "%);\n  "])), cycle * 100);
});
var TabPanel = react_1.forwardRef(function TabPanel(_a, ref) {
    var as = _a.as, _b = _a.role, role = _b === void 0 ? 'tabpanel' : _b, index = _a.index, children = _a.children, props = __rest(_a, ["as", "role", "index", "children"]);
    warnMissingIndex_1.default(index, 'TabPanel', 'TabPanels');
    var _c = TabsContext_1.useTabsContext(), activeIndex = _c.activeIndex, cycle = _c.cycle, id = _c.id;
    var isActive = activeIndex === index;
    var dataCoral = {};
    if (!isActive) {
        dataCoral['data-coral-hidden'] = '';
    }
    var unmount = TabsContext_1.useTabPanelsContext().unmount;
    return (react_1.default.createElement(TabPanelContent, __assign({ as: as, role: role, ref: ref, cycle: cycle, id: "tabs:" + id + "-" + index + "-tab-panel", "aria-hidden": !isActive, "aria-labelledby": "tabs:" + id + "-" + index + "-tab" }, dataCoral, props), !isActive && unmount ? null : children));
});
exports.default = react_1.memo(TabPanel);
var templateObject_1, templateObject_2, templateObject_3;
